import en from './languages/en/en.json'
import fi from './languages/fi/fi.json'
import sw from './languages/sw/sw.json'

export const countryLabel = { US: 'English', FI: 'Finnish', SW: 'Swedish' }
export const countries = ['US', 'FI', 'SW']
export const resources = { en, fi, sw }
